<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div *ngIf="loggedIn" class="user-profile" style="background-image: url(assets/images/background/user-info-generic.jpg);">
  <!-- User profile image -->
  <div class="profile-img">
    <img *ngIf="profilePicUrl" [src]="profilePicUrl" alt="user">
    <span *ngIf="!profilePicUrl" class="initial">{{ userName?.length > 0 ? userName.charAt(0) : '' }}</span>
  </div>
  <!-- User profile text-->
  <!-- ============================================================== -->
  <!-- Profile - style you can find in header.scss -->
  <!-- ============================================================== -->
  <div class="profile-text">
    <a [matMenuTriggerFor]="sdprofile" class=""> {{ userName }}
      <i class="ti-angle-down font-12 m-l-5"></i>
    </a>
  </div>
  <mat-menu #sdprofile="matMenu" class="mymegamenu">
    <!-- <button mat-menu-item>
      <mat-icon>settings</mat-icon> Settings
    </button>
    <button mat-menu-item>
      <mat-icon>account_box</mat-icon> Profile
    </button>
    <button mat-menu-item>
      <mat-icon>notifications_off</mat-icon> Disable notifications
    </button> -->
    <button mat-menu-item (click)="onClickSignOut()">
      <mat-icon>exit_to_app</mat-icon> Sign Out
    </button>
  </mat-menu>
</div>

<mat-nav-list appAccordion>
  <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems.menuItems" routerLinkActive="selected"
    group="{{menuitem.state}}" (click)="scrollToTop()">
    <a class="" appAccordionToggle [routerLink]="['/', menuitem.state]" *ngIf="menuitem.type === 'link'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span *ngIf="menuitem.beta" class="beta-badge">BETA</span>
      <span>{{ menuitem.name | translate }}</span>
      <span fxFlex></span>
      <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
    </a>

    <a class="" appAccordionToggle href="{{menuitem.state}}" *ngIf="menuitem.type === 'extLink'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name | translate }}</span>
      <span fxFlex></span>
      <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
    </a>
    <a class="" appAccordionToggle href="{{menuitem.state}}" target="_blank" *ngIf="menuitem.type === 'extTabLink'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name | translate}}</span>
      <span fxFlex></span>
      <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
    </a>

    <a class="" appAccordionToggle href="javascript:;" *ngIf="menuitem.type === 'sub'">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name | translate }}</span>
      <span fxFlex></span>
      <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
      <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
    </a>
    <mat-nav-list class="sub-item" *ngIf="menuitem.type === 'sub'">
      <mat-list-item *ngFor="let childitem of menuitem.children; let j=index; let i = childitem"
        routerLinkActive="selected">
        <a [routerLink]="['/', menuitem.state, childitem.state ]" *ngIf="childitem.type === 'link'" class="relative" routerLinkActive="selected" (click)="itemSelect[i]=j">
          <span *ngIf="childitem.beta" class="beta-badge">BETA</span>
          {{ childitem.name | translate}}
        </a>
        <a href="{{childitem?.state ?? ''}}" *ngIf="childitem.type === 'externalLink'" class="relative" target="_blank"
          (click)="itemSelect[i]=j">{{ childitem.name | translate}}</a>
      </mat-list-item>
      <mat-list-item *ngFor="let childitem of menuitem.children; let j=index; let i=childitem">
        <a class="" href="javascript: void(0);" *ngIf="childitem.type === 'subchild'" (click)="itemSelect[i]=j"
          [ngClass]="j==itemSelect[i]? 'selected' : ''">
          <span>{{ childitem.name | translate }}</span>
          <span fxFlex></span>
          <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
        </a>
        <mat-nav-list class="child-sub-item" *ngIf="childitem.type === 'subchild'">
          <mat-list-item *ngFor="let child of childitem.subchildren" routerLinkActive="selected">
            <a [routerLink]="['/', menuitem.state, childitem.state, child.state ]" *ngIf="child.type !== 'externalLink'" routerLinkActive="selected">
              <span *ngIf="child.beta" class="beta-badge">BETA</span>
              {{child.name | translate}}
            </a>
            <a href="{{child.state}}" *ngIf="child.type === 'externalLink'" target="_blank">
              <span *ngIf="child.beta" class="beta-badge">BETA</span>
              {{child.name | translate}}
            </a>
          </mat-list-item>
        </mat-nav-list>
      </mat-list-item>
    </mat-nav-list>

    <div class="separator text-muted" *ngIf="menuitem.type === 'separator'">
      <span>{{ menuitem.name | translate }}</span>
    </div>
  </mat-list-item>
</mat-nav-list>
